import { formatDate, formatDateRange } from "~vue/utils/formatDate";
import { DateTime } from "luxon";

const DAYS_IN_WEEK = 7;

export const addWeeks = (weekStart: Date, amount: number): Date => {
    const nextWeek = new Date(weekStart);
    nextWeek.setDate(nextWeek.getDate() + amount * DAYS_IN_WEEK);
    return nextWeek;
};

export const getWeekStart = (date: Date): Date => {
    const weekStart = new Date(date);
    weekStart.setHours(12, 0, 0, 0);
    weekStart.setDate(weekStart.getDate() - ((weekStart.getDay() + DAYS_IN_WEEK - 1) % DAYS_IN_WEEK));
    return weekStart;
};

export const getWeekEnd = (weekStart: Date): Date => {
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekEnd.getDate() + DAYS_IN_WEEK - 1);
    return weekEnd;
};

export const getWeekKey = (weekStart: Date): string => {
    const year = weekStart.getFullYear();
    const month = String(weekStart.getMonth() + 1).padStart(2, "0");
    const day = String(weekStart.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

export const parseCalendarDate = (date: string): Date => {
    const [year, month, day] = date.split("-").map(Number);
    return new Date(year, month - 1, day, 12);
};

export const formatCalendarDate = (date: Date): string => formatDate(date, "date");

export const formatWeekRange = (weekStart: Date): string => formatDateRange(weekStart, getWeekEnd(weekStart), "date");

export const formatCompactWeekRange = (weekStart: Date): string => formatDateRange(weekStart, getWeekEnd(weekStart), "month-day", { year: "never" });

// Luxon parses an ISO week date (2026-W38) straight to that week's Monday, so callers do not
// have to walk back from 4 January by hand. Returns the raw period if it is not a valid ISO week.
export const formatIsoWeekStart = (period: string): string => {
    const monday = DateTime.fromISO(period, { zone: "utc" });
    return monday.isValid ? formatDate(monday, "month-day-long") : period;
};
